import Vue from 'vue';
import { VueReCaptcha } from 'vue-recaptcha-v3';

Vue.use(VueReCaptcha, {
    siteKey: "6Lcsp18pAAAAAEiRJf4e7ZU1mlgzHu8lRnT_Z_9B",
    loaderOptions: { useRecaptchaNet: true, autoHideBadge: true }
});